import { DialogConfig } from '@ui/dialog/dialog.types';

/** Platform navbar height ($navbar-height) plus the optional sticky banner above it. */
const NAVBAR_OFFSET = 'calc(60px + var(--app-banner-height, 0px))';

/**
 * Dialog config of the global Ask panel (.project#1877): a 400px column docked
 * to the right edge, full height UNDER the platform navbar, like the prototype.
 *
 * Kept beside the lazy factory (no component imports) because the eagerly
 * loaded launcher passes it to `DialogService.openLazy`. It keeps the shared
 * right-side panel class, so the global pane styles still apply, and leaves the
 * backdrop class unset: the default CDK backdrop is transparent here, so the
 * page stays visible next to the panel instead of being dimmed.
 */
export const COPILOT_ASK_PANEL_DIALOG_CONFIG: DialogConfig = {
  width: '400px',
  maxWidth: '100vw',
  height: `calc(100vh - 60px - var(--app-banner-height, 0px))`,
  position: {
    top: NAVBAR_OFFSET,
    right: '0',
  },
  autoFocus: false,
  panelClass: ['app-right-side-dialog-panel', 'app-copilot-ask-panel-pane'],
};
